<template>
  <v-app id="login">
    <v-content>
      <v-container fluid fill-height>                
        <v-row justify="center">
          <v-col xs="12" sm="8" md="4">
            <div class="logo-wrapp">
              <img src="logo_vertical.png" alt="">
            </div>
            <v-card class="elevation-12 text-center">
              <v-card-title>
                <slot name="title"></slot>
              </v-card-title>
              <v-card-text class="gradient">
                <slot></slot>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
export default {

  name: 'AuthMain',

  data () {
    return {

    }
  }
}
</script>

<style scoped>
  #login {
    background-color: #21D4FD;
    background-image: linear-gradient(19deg, #21D4FD 0%, #B721FF 100%);
    /* background: url(/login_bg.jpg) no-repeat center center; */
    /* background-image: linear-gradient(to right, #4facfe 0%, #00f2fe 100%); */
    position: relative;
  }
  #login:before{
    content: "" ;
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    display: block;
    /* background: linear-gradient(to top, #1e1c4c, rgba(242, 0, 0, 0)) */
  }
  .logo-wrapp {
    width: 175px;
    height: 175px;
    border-radius: 50%;
    display: block;
    overflow: hidden;
    background-color: #fff;
    text-align: center;
    line-height: 230px;
    padding-top: 20px;
    margin: 40px auto;
    border: 4px solid #d9d3e3;

  }
  .logo-wrapp img {
    width: 120px;
    height: 120px;
  }
  .gradient {    
  }
</style>
